import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import { FormRangeDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_range_picker_input";
import { ReportsTreinamentosFuncionariosForm } from "../../../schemas/Principal_rh/reports_treinamentos_funcionarios";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";

import PrimaryButton from "../../../../../../common/components/primary_button";
import FormContainer from "../../../../../../common/components/form_container";

/**
 * ReportsTreinamentosFuncionarios
 */

type Props = {
  open: boolean,
  saving: boolean,
  loading: boolean,
  funcionariosDropdown: FuncionarioDropDown[],
  centroCustosDropdown: CentroCustoDropDown[],
  onClose: () => void,
  onSubmit: (form: ReportsTreinamentosFuncionariosForm) => void,
};

export const ReportsTreinamentosFuncionariosModal = ({
  open,
  saving,
  loading,
  funcionariosDropdown,
  centroCustosDropdown,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ReportsTreinamentosFuncionariosForm>({});

  useEffect(() => {
    if (open) hookForm.reset();
  }, [hookForm, open]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(onSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "40rem",
          },
        },
      }}>
      <DialogTitle>
        Relatório Treinamentos Funcionários
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={loading || saving}>
          <FormContainer title={"Informações"} arrangement="fullRow">
            <>
              <DefaultFormMultiAutocomplete
                name='centroCustos'
                label='Centro de Custo'
                options={centroCustosDropdown}
                getOptionKey={(x) => x.id}
                getOptionLabel={(x) => x.title}
                reactHookForm={hookForm} />

              <FormRangeDatePickerInput
                label='Data Realizado'
                name='dataRealizado'
                reactHookForm={hookForm}
              />

              <DefaultFormMultiAutocomplete
                name='funcionarios'
                label='Funcionários'
                options={funcionariosDropdown}
                getOptionKey={x => x.idFuncionario}
                getOptionLabel={(x) => x.nome}
                reactHookForm={hookForm} />

              <FormRangeDatePickerInput
                label='Data Avaliação'
                name='dataAvaliacao'
                reactHookForm={hookForm}
              />

              <DefaultFormMultiAutocomplete
                name='eficaz'
                label='Eficaz'
                options={[{ id: 0, nome: 'Sim' }, { id: 1, nome: 'Não' }]}
                getOptionKey={(x) => x.id}
                getOptionLabel={(x) => x.nome}
                reactHookForm={hookForm}
              />

            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              <PrimaryButton
                type="submit"
                buttonColor="primary-green">
                Gerar
              </PrimaryButton>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}